import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";
import { ArticleActionWidget } from "~/components/article/article-action-widget";
import { ArticleAdditionalInfoBox } from "~/components/article/article-additional-info-box";
import { ArticleAuthorBlock } from "~/components/article/article-author-block";
import { ArticleAuthorsDetails } from "~/components/article/article-author-details";
import { ArticleCommentsDrawer } from "~/components/article/article-comments-drawer";
import { ArticleCommentsTrigger } from "~/components/article/article-comments-trigger";
import { ArticleCorrectionsWidget } from "~/components/article/article-corrections-widget";
import { ArticleImageGallery } from "~/components/article/article-image-gallery";
import { ArticleLeading } from "~/components/article/article-leading";
import { ArticleLeftHandSideWidgets } from "~/components/article/article-left-hand-side-widgets";
import { ArticleMoreOnThisList } from "~/components/article/article-more-on-this-list";
import { ArticlePaywallContainer } from "~/components/article/article-paywall-container";
import { ArticleReaction } from "~/components/article/article-reaction";
import { ArticleSections } from "~/components/article/article-sections";
import { ArticleShareWidget } from "~/components/article/article-share-widget";
import { ArticleSpeechInlineWidget } from "~/components/article/article-speech";
import { ArticleSponsor } from "~/components/article/article-sponsor";
import { ArticleTopicFollowWidget } from "~/components/article/article-topic-follow-widget";
import { ArticleTopics } from "~/components/article/article-topics";
import { ArticleVocabBox } from "~/components/article/article-vocab-box";
import { ContentBody } from "~/components/content/content-body";
import { ContentHeadline } from "~/components/content/content-headline";
import { ContentLiveTag } from "~/components/content/content-live-tag";
import { ContentSubHeadline } from "~/components/content/content-sub-headline";

export const ContentReadMoreButtonContainer = styled.div`
  display: block;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const ArticleRenderContainer = styled.div`
  & > *:first-child {
    padding-block: 40px;
  }
`;

export const StyledAdSlot = styled(AdSlot)``;
export const StyledArticleActionWidget = styled(ArticleActionWidget)``;
export const StyledArticleAdditionalInfoBox = styled(ArticleAdditionalInfoBox)``;
export const StyledArticleAuthorBlock = styled(ArticleAuthorBlock)``;
export const StyledArticleAuthorsDetails = styled(ArticleAuthorsDetails)``;
export const StyledArticleCommentsDrawer = styled(ArticleCommentsDrawer)``;
export const StyledArticleCommentsTrigger = styled(ArticleCommentsTrigger)``;
export const StyledArticleCorrectionsWidget = styled(ArticleCorrectionsWidget)``;
export const StyledArticleImageGallery = styled(ArticleImageGallery)``;
export const StyledArticleLeading = styled(ArticleLeading)``;
export const StyledArticleLeftHandSideWidgets = styled(ArticleLeftHandSideWidgets)``;
export const StyledArticleLiveTag = styled(ContentLiveTag)``;
export const StyledArticleMoreOnThisList = styled(ArticleMoreOnThisList)``;
export const StyledArticlePaywallContainer = styled(ArticlePaywallContainer)``;
export const StyledArticleSections = styled(ArticleSections)``;
export const StyledArticleShareWidget = styled(ArticleShareWidget)``;
export const StyledArticleSponsor = styled(ArticleSponsor)``;
export const StyledArticleTopicFollowWidget = styled(ArticleTopicFollowWidget)``;
export const StyledArticleTopics = styled(ArticleTopics)``;
export const StyledArticleVocabBox = styled(ArticleVocabBox)``;

export const PrimaryContentBody = styled(ContentBody)``;

type SecondlyContentBodyProps = {
  $isShow: boolean;
};
export const SecondlyContentBody = styled(ContentBody, {
  ...transientOptions,
})<SecondlyContentBodyProps>(
  props => css`
    display: none;
    ${props.theme.breakpoints.up("tablet")} {
      display: block;
    }

    ${props.$isShow && "display: block;"}
  `,
);

export const StyledContentHeadline = styled(ContentHeadline)``;
export const StyledContentSubHeadline = styled(ContentSubHeadline)``;
export const StyledArticleSpeechInlineWidget = styled(ArticleSpeechInlineWidget)``;
export const StyledArticleReaction = styled(ArticleReaction)`
  display: flex;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledCommentAndReactionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  ${StyledArticleCommentsTrigger} {
    flex-grow: 1;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export type InlinePaywallOverlayerProps = {
  $height?: "normal" | "small";
  $variant?: "light" | "dark";
};
export const InlinePaywallOverlayer = styled.div<InlinePaywallOverlayerProps>`
  position: absolute;
  inset-block-end: 0;

  ${props =>
    props.$height === "normal"
      ? css`
          block-size: 200px;
        `
      : css`
          block-size: 110px;
        `}

  ${props =>
    props.$variant === "dark"
      ? css`
          inset-inline: -120px;

          inline-size: auto;

          background: linear-gradient(180deg, rgba(28, 30, 34, 0), #1c1e22 63%);
        `
      : css`
          inline-size: 100%;

          background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #ffffff 63%);
        `}
`;
